export const navigationUrls = {
  auth: {
    login: '/auth/login',
    confirmation: '/auth/confirmation'
  },
  calendar: { index: '/calendar' },
  events: {
    index: '/events',
    create: '/events/create',
    vistaCreate: '/events/create/vista',
    /**
     * Редактирование мероприятия
     * @param id - id мероприятия
     */
    edit: (id: string) => `/events/edit/${id}`,
    /**
     * Редактирование мероприятия висты
     * @param id - id мерпориятия
     */
    editVista: (id: string) => `/events/edit/vista/${id}`,
    /**
     * Приглашение гостей на мероприятие
     * @param id - id мероприятия
     */
    guestsAssignment: (id: string) => `/events/${id}/guests-invitation`
  },
  locations: { index: '/locations' },
  guests: { index: '/guests', create: '/guests?create=true' },
  hallTemplates: {
    index: '/hall-templates',
    create: '/hall-templates/create',
    /**
     * Редактирования шаблона зала
     * @param id - id шаблона
     */
    edit: (id: string) => `/hall-templates/edit/${id}`
  },
  tickets: {
    index: '/tickets',
    /**
     * Билеты мероприятия
     * @param eventId - id мероприятия
     */
    list: (eventId: string) => `/tickets/event/${eventId}`
  },
  users: {
    index: '/users',
    showCreate: '/users?create=true',
    /**
     * Данные пользователя
     * @param id - id пользователя
     */
    details: (id: string) => `/users/${id}`
  },
  archive: {
    index: '/archive',
    /**
     * Архивное мероприятие
     * @param id - id мероприятия
     */
    archiveCard: (id: string) => `/archive/${id}`
  },
  tags: {
    index: '/tags',
    showCreate: '/tags?create=true'
  }
};
